import * as Sentry from '@sentry/react';
import settings from '../../config/settings';

export default function registerRaven() {
    Sentry.init({
        dsn: settings.SentryioKey,
        environment: ENVIRONMENT,
        maxBreadcrumbs: 10,
    });
}
